if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.photoButtons = this.querySelectorAll('[data-photo-direction]');
        this.photoButtons.forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', () => this.changePhoto(Number(button.dataset.photoDirection)));
        });
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open') || !this.hasAttribute('data-photo-gallery')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.changePhoto(event.key === 'ArrowRight' ? 1 : -1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        const content = this.querySelector('[role="document"]');
        this.photos = Array.from(content.children).filter((element) => element.matches('img[data-media-id]'));
        this.photoIndex = this.photos.findIndex((image) => image.dataset.mediaId === opener.dataset.mediaId);
        this.toggleAttribute('data-photo-gallery', this.photoIndex >= 0);
        const showNavigation = this.photoIndex >= 0 && this.photos.length > 1;
        this.photoButtons.forEach((button) => {
          button.hidden = !showNavigation;
          button.disabled = !showNavigation;
        });
        this.querySelector('[data-photo-counter]').hidden = this.photoIndex < 0;
        super.show(opener);
        this.showActiveMedia();
      }

      changePhoto(direction) {
        if (!this.hasAttribute('data-photo-gallery') || this.photos.length < 2) return;
        this.photoIndex = (this.photoIndex + direction + this.photos.length) % this.photos.length;
        this.activatePhoto();
      }

      activatePhoto() {
        const content = this.querySelector('[role="document"]');
        Array.from(content.children).forEach((element) => {
          element.classList.toggle('active', element === this.photos[this.photoIndex]);
        });
        content.scrollTop = 0;
        content.scrollLeft = 0;
        this.querySelector('[data-photo-current]').textContent = this.photoIndex + 1;
        this.querySelector('[data-photo-total]').textContent = this.photos.length;
      }

      showActiveMedia() {
        if (this.hasAttribute('data-photo-gallery')) {
          this.activatePhoto();
          return;
        }

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
